var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveButtonIcon = function SvgSaveButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108698",
    d: "M18.46 0H1.5A1.5 1.5 0 0 0 0 1.5v16.96a1.5 1.5 0 0 0 1.5 1.5h16.96a1.5 1.5 0 0 0 1.5-1.5V1.5a1.5 1.5 0 0 0-1.5-1.5ZM7.983 1h3.991v2.994H7.983Zm10.976 17.462a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5V1.5a.5.5 0 0 1 .5-.5h5.488v2.994a1 1 0 0 0 1 1h3.991a1 1 0 0 0 1-1V1h5.488a.5.5 0 0 1 .5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108699",
    d: "M9.977 6.984a4.989 4.989 0 1 0 4.989 4.989 5 5 0 0 0-4.989-4.989Zm0 8.981a3.991 3.991 0 1 1 3.991-3.991 4 4 0 0 1-3.991 3.991Z"
  }))));
};
export default SvgSaveButtonIcon;